<template>
  <div
    ref="container"
    class="hero-text"
    :class="[
      {
        'hero-text--visible': visible,
        'hero-text--invert': invert,
        'hero-text--alone': alone,
        'hero-text--scale': scale
      },
      `hero-text--${ align }`,
      `hero-text--${ name }`
    ]"
    :style="{ fontSize: `${ fontSize }px` }"
  >
    <span class="hero-text__content" v-html="text"/>
    <slot/>
  </div>
</template>

<script>
export default {
  props: {
    invert: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      default: ''
    },
    align: {
      type: String,
      default: 'right',
      validator: propValue => ['right', 'left'].includes(propValue)
    },
    alone: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true,
      validator: propValue => (
        ['creativity', 'execution', 'love', 'delivery'].includes(propValue)
      )
    },
    scale: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fontSize: 0
    }
  },
  mounted () {
    this.setFontSize()
    window.addEventListener('resize', this.setFontSize.bind(this))
  },
  methods: {
    setFontSize () {
      const { container } = this.$refs

      if (!container) return
      this.fontSize = container.offsetHeight
    }
  }
}
</script>

<style lang="scss" scoped>
  .hero-text {
    pointer-events: none;
    transition: opacity .15s ease,
                filter .18s ease;
    opacity: 0;
    will-change: filter;

    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;

    font-family: $font-default-bold;
    line-height: 1.11;

    color: #fff;

    @include media-up(md) {
      color: #000;
    }

    &--visible {
      opacity: 1;
    }

    &--invert {
      filter: invert(100%);
    }

    &--left {
      text-align: left;
    }

    &--right {
      text-align: right;
    }

    &__content {
      display: block;
      width: 100%;

      position: absolute;
      left: 0;
      bottom: #{2 * 100% / 19}; // 2 x hero line height

      font-size: .1em;
      margin-bottom: 0.175em;

      @include media-up(md) {
        font-size: .23em;
        margin-bottom: 0.135em;
      }

    }

    &--alone &__content {
      bottom: #{6 * 100% / 19};
      margin-bottom: 0.2em;
    }

    // Mobile animation
    @include media-down(md) {
      &--creativity &__content,
      &--delivery &__content {
        bottom: #{5 * 100% / 19};
      }

      &--execution &__content {
        margin-left: .1em;
      }

      &--execution.hero-text--scale {
        transform: scale(2) translate(-15%, -25%);
      }

      &--delivery &__content {
        margin-left: -.3em;
      }

      &--delivery.hero-text--scale {
        transform: scale(2) translate(10%, -5%);
      }

      &--love &__content {
        font-size: .175em;
        margin-left: .87em;
        bottom: #{12 * 100% / 19};
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HeroAnimation/HeroText.vue